// Export apis
import * as auth from './auth.apis';
import * as pdf from './pdf.apis';
import * as template from './template.apis';
import * as user from './user.apis';
import * as esg from './esg.apis';
import * as portfolio from './portfolio.apis';
import * as cdn from './cdn.apis';
import * as theme from './theme.apis';
import * as portfolioUpload from './portfolio-upload.apis';
import * as settings from './settings.apis';
import * as esgFund from './esgFund.apis';

export default {
  auth,
  pdf,
  template,
  user,
  esg,
  esgFund,
  portfolio,
  cdn,
  theme,
  portfolioUpload,
  settings
};
